<template>
  <div class="container px-2">
    <div class="wrapper-title-threeitems">
      <h2>{{ title }}</h2>
      <!-- <div class="form-field btn-input with-icon-ahead full" v-if="type === 'main'">
        <span><icon name="search" class="icon" scale="2"></icon></span>
        <span class="full"><input type="text" placeholder="Suche" v-model="searchQuery"></span>
        <span><button class="btn icon"><icon name="sliders" class="icon rotate-90"></icon></button></span>
      </div> -->
      <button class="btn orange sm:hidden" @click.prevent="goTo('shops')" v-if="type === 'teaser'">Zur Händler-Übersicht</button>
      <!--<button class="btn orange sm:hidden" @click.prevent="toggleFilterModal" v-if="type === 'main'">Filter</button>-->
    </div>
    <div class="flex flex-wrap -mx-2">
      <div class="w-1/3 md:w-1/2 sm:w-full px-2 mb-4" v-for="shop in shops.data">
        <div class="card vendor-card">
          <div class="card-overlay">
            <button class="btn overlay" @click.prevent="goTo('shop', {id: shop.uid})">Zum Händler</button>
            <button class="btn icon outline green" @click.prevent="buyLive(shop)" v-if="shop.is_online">
              <span><icon class="icon" name="shopping-cart"></icon></span>
              <span>Jetzt live einkaufen</span>
            </button>
            <!-- <button class="btn orange">Aus Favoriten entfernen</button> -->
          </div>
          <span class="cat-label">
            <icon name="sliders" class="icon rotate-90"></icon>
            <span>{{ formatLabels(shop.categories.data) }}</span>
          </span>
          <img-comp :element="shop" size="s" :alt="shop.name" ></img-comp>
          <div class="lg:hidden xl:hidden flex">
            <button
                :class="['btn orange inline-block w-1/2 rounded-none', shop.is_online ? 'w-1/2' : 'w-full' ]"
                @click.prevent="goTo('shop', {id: shop.uid})">Zum Händler
            </button>
            <button v-if="shop.is_online" class="btn icon green inline-block w-1/2 rounded-none"
                    @click.prevent="buyLive(shop)">
              <span><icon class="icon" name="shopping-cart"></icon></span>
              <span>Jetzt live einkaufen</span>
            </button>
          </div>
          <div class="text">
            <h3>{{ shop.name }}</h3>
            <span>{{ shop.location }} </span>&#149;<span :class="shop.is_online ? 'open' : 'closed'">{{ shop.is_online ? ' Geöffnet' : ' Geschlossen' }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="load-more-container md:hidden lg:hidden sm:center" v-if="type === 'teaser'">
      <button class="btn orange" @click.prevent="goTo('shops')">Zur Händler-Übersicht</button>
    </div>
    <div class="load-more-container" v-if="type === 'main' && shops.links.next && !loading">
      <button class="btn orange" @click.prevent="loadMore">Mehr laden</button>
    </div>
    <div v-if="loading" class="flex items-center">
      <div class="flex-1 text-grey-darker text-center px-4 py-4 m-4">
        <cg-loader :show="true"></cg-loader>
      </div>
    </div>
  </div>
</template>

<script>
  import formatting from '@/mixins/formatting.js'
  import helpers from '@/mixins/helpers.js'
  import { EventBus } from '@/assets/js/event-bus.js'
  import {mapActions, mapGetters} from 'vuex'
  import CgLoader from '../components/menus/cgLoader'

  export default {
    name: 'shoplist',
    components: {
      CgLoader
    },
    props: {
      shops: {
        type: Object,
        default: function () {
          return {
            data: [],
            links: {
              next: null
            }
          }
        },
        required: true
      },
      type: {
        type: String,
        default: 'main'
      },
      title: {
        type: String,
        default: ''
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    mixins: [formatting, helpers],
    data () {
      return {
        searchQuery: '',
        buyLiveToast: null
      }
    },
    methods: {
      toggleFilterModal () {
        EventBus.$emit('toggleFilterModal')
      },
      loadMore () {
        this.$emit('more')
      },
      buyLive (shop) {
        if (this.isAuthenticated) {
          if (!this.buyLiveToast) {
            this.buyLiveToast = this.$toasted.info('Wird gespeichert...', {
              theme: 'primary',
              position: 'top-right',
              duration: 10000,
              icon: 'info'
            })
            var self = this
            this.getInLine({
              shop: shop.uid,
              cb () {
                self.$toasted.success('Du stehst jetzt bei ' + shop.name, {
                  theme: 'primary',
                  position: 'top-right',
                  duration: 10000,
                  action: {
                    text: 'X',
                    class: 'toastBtn',
                    onClick: (e, toastObject) => {
                      toastObject.goAway(0)
                    }
                  },
                  icon: 'check'
                })
                self.buyLiveToast.goAway(100)
                self.buyLiveToast = null
              },
              errorCb () {
                self.$toasted.error('Ein Fehler ist aufgetreten. Bitte versuch es nochmal oder kontaktiere unseren Support', {
                  theme: 'primary',
                  position: 'top-right',
                  duration: 10000,
                  action: {
                    text: 'X',
                    class: 'toastBtn',
                    onClick: (e, toastObject) => {
                      toastObject.goAway(0)
                    }
                  },
                  icon: 'check'
                })
                self.buyLiveToast.goAway(100)
                self.buyLiveToast = null
              }
            })
          }
        } else {
          EventBus.$emit('toggleLoginModal')
        }
      },
      ...mapActions([
        'getInLine'
      ])
    },
    computed: {
      ...mapGetters({
        shop: 'shop_get_details',
        isAuthenticated: 'auth_is_authenticated'
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ShopList.vue